import React from 'react';
import { useState } from 'react';
import { Trans } from 'react-i18next';

import Avatar from '@material-ui/core/Avatar';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import BusinessIcon from '@material-ui/icons/Business';

import User from '../../../../types/User';
import AuditorCompaniesDialog from '../../../AuditorCompaniesDialog/AuditorCompaniesDialog';
import { StyledList, StyledListItem } from './styled';

interface Props {
    user: User;
    updateData: () => void;
    saveIfNeeded: () => Promise<void>;
    isLoading?: boolean;
}

const AuditorFooter = (props: Props) => {
    const { user, updateData, saveIfNeeded, isLoading } = props;

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const countCompanies = user.companies.length;

    return (
        <>
            <StyledList>
                <StyledListItem button onClick={() => setIsDialogOpen(true)} >
                    <ListItemAvatar>
                        <Avatar>
                            <BusinessIcon />
                        </Avatar>
                    </ListItemAvatar>

                    <ListItemText primary={(
                        <Trans i18nKey='dialogs.user_details.number_of_companies' count={countCompanies} >
                            _<strong>{{countCompanies}}</strong>_
                        </Trans>
                    )} />
                </StyledListItem>
            </StyledList>

            <AuditorCompaniesDialog
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                userId={user.id}
                companies={user.companies}
                updateData={updateData}
                saveIfNeeded={saveIfNeeded}
                isLoading={isLoading}
            />
        </>
    );
};

export default AuditorFooter;
